{
	"searchAssets": {
		"title": "Выберите тикер",
		"inputLabel": "Начните вводить тикер",
		"columnTicker": "Тикер",
		"columnExchange": "Биржа",
		"columnDescription": "Описание",
		"tickersNotFound": "Тикеры не найдены",
		"searching": "Поиск...",
		"notHasWidgetUseLiveTicker": "Нет виджетов использующих тикер",
		"deleteSuccess": "{{symbol}} удален из избранного",
		"deleteFail": "Не удалось удалить {{symbol}} из избранного",
		"addSuccess": "{{symbol}} добавлен в избранное",
		"addFail": "Не удалось добавить {{symbol}} в избранное"
	}
}
